import { TrackType } from '@/App/remotion/MainPlayer/types/Track/Type';
import { TextElement } from '@/App/remotion/MainPlayer/types/Element/TextElement';
import { Clip } from '@/domains/asset';

export const getTextElementById = (clipData: Clip, textElementId: string): TextElement => {
  return clipData.asset_metadata.player_config?.playerConfig.tracks
    .filter(track => track.type === TrackType.ELEMENTS)
    .flatMap(track => track.elements)
    .find(element => element.id === textElementId) as TextElement;
};
